import type { AddressSuggestion, NormalizedAddress } from '@@partner:types:app'

export const normalizeAddressSuggestion = (
  addressObj: AddressSuggestion
): NormalizedAddress => {
  const {
    unrestricted_value: fullAddress = '',
    data: { house_type = '', house = '', street_with_type = '' }
  } = addressObj

  return {
    address: addressObj.value,
    fullAddress
  }
}

export const validateAddressSuggestion = (
  suggestion: AddressSuggestion
): boolean => {
  if (
    suggestion.data.geo_lat &&
    suggestion.data.geo_lon &&
    suggestion.unrestricted_value &&
    (!!suggestion.data.street_with_type || !!suggestion.data.city_district) &&
    suggestion.data.house
  ) {
    return true
  }
  return false
}
